module.exports = __webpack_public_path__ + "media/images/flags/4x3/asm-e855dcb39cffcaf19b91a3c7ffa294c3.svg";